/* Robocenter: voraussichtlichen Liefertag berechnen (Werktage Mo–Fr ohne österreichische Feiertage).
   data-min/data-max = Werktage bis zur Zustellung, data-cutoff = Bestellschluss (Stunde, Ortszeit Österreich). */
(function () {
  if (customElements.get('rc-delivery')) return;

  function easter(y) {
    const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, month - 1, day);
  }
  const cache = {};
  function holidays(y) {
    if (cache[y]) return cache[y];
    const key = (d) => d.getMonth() + 1 + '-' + d.getDate();
    const set = new Set(['1-1', '1-6', '5-1', '8-15', '10-26', '11-1', '12-8', '12-24', '12-25', '12-26', '12-31']);
    const e = easter(y);
    [1, 39, 50, 60].forEach((n) => set.add(key(new Date(y, e.getMonth(), e.getDate() + n))));
    return (cache[y] = { has: (d) => set.has(key(d)) });
  }
  function isWorkday(d) {
    const wd = d.getDay();
    return wd !== 0 && wd !== 6 && !holidays(d.getFullYear()).has(d);
  }
  function addWorkdays(start, n) {
    const d = new Date(start);
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (isWorkday(d)) n--;
    }
    return d;
  }
  function nowInAustria() {
    try {
      const p = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Vienna', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
      const v = (t) => +p.find((x) => x.type === t).value;
      return { date: new Date(v('year'), v('month') - 1, v('day')), hour: v('hour') };
    } catch (e) {
      const n = new Date();
      return { date: new Date(n.getFullYear(), n.getMonth(), n.getDate()), hour: n.getHours() };
    }
  }
  const fmt = new Intl.DateTimeFormat('de-AT', { weekday: 'short', day: '2-digit', month: '2-digit' });

  class RcDelivery extends HTMLElement {
    connectedCallback() {
      const min = parseInt(this.dataset.min, 10), max = parseInt(this.dataset.max, 10);
      const cutoff = parseInt(this.dataset.cutoff, 10) || 12;
      const out = this.querySelector('[data-rc-date]');
      if (!out || isNaN(min) || isNaN(max)) return;
      const now = nowInAustria();
      let start = now.date;
      // Nach Bestellschluss oder am Wochenende/Feiertag zählt der nächste Werktag als Bestelltag.
      if (!isWorkday(start) || now.hour >= cutoff) start = addWorkdays(start, 1);
      const a = addWorkdays(start, min), b = addWorkdays(start, max);
      out.textContent = min === max ? fmt.format(a) : fmt.format(a) + ' – ' + fmt.format(b);
      out.parentElement.hidden = false;
    }
  }
  customElements.define('rc-delivery', RcDelivery);
})();
